import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const customerApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Customer.api}`;

  // Add id as query parameter
  if (data?.id) {
    url += `?id=${data.id}`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const matrixCustomerApi = async (data) => {
  let url = '';
  if (data?.id) {
    url = `${env}${
      API_ENDPOINT.Customer.matrixApi + '/' + data.id + '?duration=' + data?.duration
    }`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const ticketCustomerApi = async (data) => {
  let url = '';
  if (data?.id) {
    url = `${env}${API_ENDPOINT.Customer.ticketApi + '/' + data.id + '?status=' + data?.status}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
export const updateCustomerApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Customer.api + '/' + data.customerId}`, data.data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCountryList = async () => {
  let url = `${env}${API_ENDPOINT.CountryList.api}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
